import { render, staticRenderFns } from "./mail-templates-list.vue?vue&type=template&id=2311f499&scoped=true"
import script from "./mail-templates-list.vue?vue&type=script&lang=js"
export * from "./mail-templates-list.vue?vue&type=script&lang=js"
import style0 from "./mail-templates-list.vue?vue&type=style&index=0&id=2311f499&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2311f499",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2311f499')) {
      api.createRecord('2311f499', component.options)
    } else {
      api.reload('2311f499', component.options)
    }
    module.hot.accept("./mail-templates-list.vue?vue&type=template&id=2311f499&scoped=true", function () {
      api.rerender('2311f499', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/mail-templates/list/mail-templates-list.vue"
export default component.exports